import { Component,OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import {  Slides, ModalController, NavController,LoadingController, NavParams } from 'ionic-angular';
import { IonicModule } from 'ionic-angular';
import {SharedService, SessionService,SportsHomeService,SportBetPanelService, SocketService} from 'baseline-lib';
import { gametype, Sportshome, game} from 'baseline-lib';
import { Subject,} from 'rxjs';
import { Global } from '../../../global/global';
import { SportsDetailPage } from '../sports-detail/sports-detail';
import { SportsBetslipPage } from '../sports-betslip/sports-betslip';
import { count } from '../../../../../../node_modules/rxjs/operators';
import { debug } from 'util';



/**
 * Generated class for the SportsDashboardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sports-dashboard',
  templateUrl: 'sports-dashboard.html'
})
export class SportsDashboardComponent implements OnInit{
  @Output() onclickevent: EventEmitter<any> = new EventEmitter<any>();
  @Input() menuId : number;

  text: string;
  sportsHomeObj: Sportshome;
  sub: any;
  bannerSub2: any;
  updateSearchResult: any;
  selected_game_id:number;
  selected_country_id:number=0;
  selected_league_id:number;
  game_opened:boolean = false;
  country_opened:boolean = false;
  league_opened:boolean = false;
  league_list:any;
  sports_selection: string;
  loader:any;
  inplay : boolean = false;
  fromBetSlip : any;
  isLive : boolean = false;
  isContentLoaded : boolean = false;
  dataObj : string[] = [];

  constructor(private _sportsHomeService: SportsHomeService,
    private _sportBetPanelService : SportBetPanelService,
    public _globalData : Global,
    public navCtrl : NavController, public _sharedService: SharedService,
    public loadingCtrl: LoadingController, public _socketService : SocketService, public navParams: NavParams
  )
  {
    this.isContentLoaded = false;
    this._sportsHomeService.sportshomeobj.gameList = [];
    console.log('Hello SportsDashboardComponent Component');
    this.loader = loadingCtrl;
    this.fromBetSlip = navParams.get('fromBetSlip');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.menuId) {
      this.menuId =  changes.menuId.currentValue;
      this.ngOnInit();
    }
  }

  ngOnInit() {
    
    if(this.menuId == 96){ // if live betting
      this.isLive = true;
      //this._sportsHomeService.setSportsGame();
      this._sportsHomeService.sportshomeobj.duration = 0;
      this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
      console.log(this.sportsHomeObj.gameList);
      this.onDurationChange(this.sportsHomeObj.durationList[0]);
      //this.sports_selection = "Live";
      this.isContentLoaded = true;
     
    }else{
      this.isLive = false;
      this.sports_selection = "Week";
      this._sportsHomeService.sportshomeobj.duration = 168;
      this._sportsHomeService.setSportsGame();
      this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
      console.log(this.sportsHomeObj.gameList);
      this.onDurationChange(this.sportsHomeObj.durationList.filter(dur=> dur.value == this.sportsHomeObj.duration)[0]);
      this.isContentLoaded = true;
    }
  }

  ngOnDestroy() {
   
    // reset durations
    this.sportsHomeObj.durationList.forEach(element => {
      element.select= false;
    });
    this._sportsHomeService.populateDuration();
    this._socketService.dispose();
    this._sportsHomeService.sportshomeobj.inplay = false;
    this._globalData.inPlay = this._sportsHomeService.sportshomeobj.inplay;
  }

  getCountriesBygame(game: game) {
   if(game.ecnt !=0)
   {
     if(this.selected_game_id == game.gameid){
      this.selected_game_id = 0;
     }
     else
     {
        this.selected_game_id = game.gameid;

        //If not live
        if (this.sportsHomeObj.duration != 0) {
          this._sportBetPanelService._removeBetPanel.next(0); // = new BehaviorSubject<number>(0); //preventing behaviour subject to take previos value
          if (game.countries.length <= 0) {
            this._sportsHomeService.getCountriesByGame(game);
            if (this._sportsHomeService.gameList.filter(g => g.gameid == game.gameid).length == 0)
              this._sportsHomeService.gameList.push(game);
          }
        }else if(this._globalData.inPlay){
          //this.navCtrl.push(SportsDetailPage,{id:game.gameid,duraId:this.sportsHomeObj.duration});
          this.dataObj[0] = game.gameid+"";
          this.dataObj[1] = this.sportsHomeObj.duration +"";
          // this.dataObj[2] = this.sportsHomeObj.duration +"";
    
          this.onclickevent.emit(this.dataObj);
        }
      }
        
    // this.startSocket(game);
  }}

  on_country_click(country){
    if(country.countryId ==this.selected_country_id){
      this.selected_country_id = 0;
    }else{
    this.selected_country_id = country.countryId;
    }
    this.league_list = country.leagues;
  }

  onclick_league(gameid, leagueid){
    this.dataObj[0] = gameid;
    this.dataObj[1] = leagueid;
    this.onclickevent.emit(this.dataObj);
    // this.navCtrl.push(SportsDetailPage,{id:gameid,tid:leagueid});
  }

  openSportsMenuPage()
  {
    this.ngOnInit();
  }

  onDurationChange(x :any) {
    
    try{
      this.sportsHomeObj.durationList.forEach(element => {
        element.select = false;
      });
  
      this.sportsHomeObj.duration = x.value;
      this._sportsHomeService.sportshomeobj.duration = x.value;
      x.select = true;
  
      //this._sharedService.showSidebarLoader();
      this._sportBetPanelService._removeBetPanel.next(0); // = new BehaviorSubject<number>(0); //preventing behaviour subject to take previos value
  
      this._sportsHomeService.gameList.forEach(game => {
        let element: HTMLElement = document.getElementById('g_' + game.gameid);
        if (element != null && !element.classList.contains('show')) {
          this._sportsHomeService.gameList.splice(this._sportsHomeService.gameList.indexOf(game), 1);
        }
      });
  
      //load live events.
      if (x.value == 0) {
        
        if (!this.inplay) { 
          this.inplay = true;
          this._sportsHomeService.sportshomeobj.inplay = true;
          this._globalData.inPlay = true;
        }
      }
      else {
        this.inplay = false;
        this._globalData.inPlay = false;
        this._sportsHomeService.sportshomeobj.inplay = false;
        this._sportsHomeService.sportshomeobj.wschId = null;
      }
      this._sportsHomeService.getGamesByGameType();

      // setTimeout(() => {
        
      //   if(this.sportsHomeObj.gameList && this.sportsHomeObj.gameList.length > 0){
      //       // Logic for bydefault selecting 1st in list.
      //     if(this._globalData.inPlay){
      //       this.dataObj[0] = this.sportsHomeObj.gameList[0].gameid +"";
      //       this.dataObj[1] =  x.value;
      //       // this.dataObj[2] = x.value;
      //       this.onclickevent.emit(this.dataObj)
      //       this.selected_game_id = this.sportsHomeObj.gameList[0].gameid;
      //     }else{
      //       this.selected_game_id = undefined;
      //       this.dataObj[0] = null;
      //       this.dataObj[1] = null;
      //       this.dataObj[2] = null;
      //       this.onclickevent.emit(undefined)
      //     }
      //   }
      // }, 200);
      
      //  this.hide_loader();
     }
    catch(err){
    //  this.hide_loader();
    }
  }

  openBetSlipPage()
  {
    if(this.fromBetSlip == "fromBetSlip")
    {
      this.navCtrl.pop()
    }
    else
    {
      this.navCtrl.push(SportsBetslipPage);
    }
  }

  show_loader(){
    this.loader = this.loadingCtrl.create({
      content: "Please Wait",
    });
    this.loader.present();
  }

  hide_loader(){
    if(this.loader){
      this.loader.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sports/sports-dashboard/sports-dashboard.ts